var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.modalData
        ? _c("customModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modalData,
                expression: "modalData",
              },
            ],
            attrs: {
              onModalClose: _vm.onModalClose,
              onModalAccept: _vm.updateNoAnswerCalls,
              modalData: _vm.modalData,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.localOrders
        ? _c("div", [
            _c(
              "table",
              {
                staticClass:
                  "table table-bordered table-hover table-sm orders_to_call",
              },
              [
                _c("thead", [
                  _c("tr", [
                    _vm.type != "viewOrder"
                      ? _c("th", [_vm._v("Порядок")])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("th", [_vm._v("Номер")]),
                    _vm._v(" "),
                    _c("th", { staticClass: "w-85x" }, [_vm._v("Доставка")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("ФИО")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Адрес")]),
                    _vm._v(" "),
                    _c("th", { staticClass: "mw-180" }, [_vm._v("Метро")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Комментарий")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Препарат")]),
                    _vm._v(" "),
                    _vm.type != "viewOrder" ? _c("th") : _vm._e(),
                    _vm._v(" "),
                    _vm.type != "viewOrder"
                      ? _c("th", [_vm._v("OK")])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.localOrders, function (order, index2) {
                    return _c(
                      "tr",
                      { key: order.id, ref: `tr_${order.id}`, refInFor: true },
                      [
                        _vm.type != "viewOrder"
                          ? _c(
                              "td",
                              {
                                staticClass: "num_order",
                                attrs: { "data-cname": "Порядковый номер" },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: order.ord,
                                      expression: "order.ord",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "number",
                                    name: `orderLine[${order.id}]`,
                                  },
                                  domProps: { value: order.ord },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        order,
                                        "ord",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("td", { attrs: { "data-cname": "Номер заявки" } }, [
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(_vm.printOrderId(order.id)),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { attrs: { "data-cname": "Дата доставки" } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(order.date) +
                                "\n                        "
                            ),
                            _vm.type != "viewOrder"
                              ? [
                                  !order.showRebook
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-warning btn-xs",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showRebookOptions(
                                                order.id
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Перенос")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  order.showRebook
                                    ? _c("div", [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: order.rebookDate,
                                                expression: "order.rebookDate",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  order,
                                                  "rebookDate",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                            },
                                          },
                                          _vm._l(
                                            order.rebookDates,
                                            function (date, index) {
                                              return _c(
                                                "option",
                                                {
                                                  domProps: {
                                                    value: date.days,
                                                  },
                                                },
                                                [_vm._v(_vm._s(date.date))]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-success btn-xs w-100",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.updateOrder(
                                                  $event,
                                                  order.id,
                                                  "rebookOrder"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("перенести")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-warning btn-xs w-100",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                order.showRebook = false
                                              },
                                            },
                                          },
                                          [_vm._v("отмена")]
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("td", { attrs: { "data-cname": "Контакты" } }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(order.order_client.name) +
                              "\n                        "
                          ),
                          _c(
                            "div",
                            { staticClass: "phone_td" },
                            _vm._l(order.phones, function (phone) {
                              return _c("p", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.printPhone(phone)) +
                                    "\n                            "
                                ),
                              ])
                            }),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { "data-cname": "Адрес" } }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(order.address) +
                              "\n                        "
                          ),
                          _vm.type != "viewOrder" && !order.showNewAddress
                            ? _c(
                                "div",
                                { staticClass: "form-group text-center" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-xs btn-info",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          order.showNewAddress = true
                                        },
                                      },
                                    },
                                    [_vm._v("Новый адрес")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          order.showNewAddress
                            ? _c("div", [
                                _c(
                                  "form",
                                  {
                                    attrs: { action: "" },
                                    on: { submit: _vm.saveNewAddress },
                                  },
                                  [
                                    _c("input", {
                                      attrs: {
                                        type: "hidden",
                                        name: "order_id",
                                      },
                                      domProps: { value: order.id },
                                    }),
                                    _vm._v(" "),
                                    _c("textarea", {
                                      staticClass: "form-control",
                                      attrs: {
                                        required: "",
                                        rows: "3",
                                        name: "new_address",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm._m(0, true),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.runnerTasks &&
                          _vm.runnerTasks.newAddress[order.id]
                            ? _c(
                                "div",
                                _vm._l(
                                  _vm.runnerTasks.newAddress[order.id],
                                  function (req, index6) {
                                    return _c("p", [
                                      _c("strong", [
                                        _vm._v(_vm._s(req.created_at)),
                                      ]),
                                      _vm._v(" новый адрес: "),
                                      _c("strong", [
                                        _vm._v(_vm._s(req.address)),
                                      ]),
                                    ])
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "metro_td",
                            attrs: { "data-cname": "Метро" },
                          },
                          [
                            !order.showMetroMenu
                              ? _c("div", [
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.printMetro(order)),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "form-group text-center" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-xs btn-info",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              order.showMetroMenu = true
                                            },
                                          },
                                        },
                                        [_vm._v("Выбрать метро")]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            order.showMetroMenu
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "v-select",
                                      {
                                        attrs: {
                                          label: "title",
                                          placeholder: "Метро",
                                          filterable: false,
                                          options: _vm.metroList,
                                        },
                                        on: { search: _vm.onSearchMetro },
                                        nativeOn: {
                                          keypress: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            $event.preventDefault()
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "option",
                                              fn: function (option) {
                                                return [
                                                  _c(
                                                    "div",
                                                    { staticClass: "d-center" },
                                                    [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(option.title)
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        _vm._s(
                                                          option.line.title
                                                        ) +
                                                          "\n                                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "selected-option",
                                              fn: function (option) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "selected d-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(option.title) +
                                                          "\n                                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: order.metro,
                                          callback: function ($$v) {
                                            _vm.$set(order, "metro", $$v)
                                          },
                                          expression: "order.metro",
                                        },
                                      },
                                      [
                                        _c("template", { slot: "no-options" }, [
                                          _vm._v(
                                            "\n                                    введите название станции..\n                                "
                                          ),
                                        ]),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group text-center p-t-5",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-xs btn-success",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.saveMetro(
                                                  $event,
                                                  order
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Ок")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-xs btn-warning",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                order.showMetroMenu = false
                                              },
                                            },
                                          },
                                          [_vm._v("Отмена")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c("td", { attrs: { "data-cname": "Комментарий" } }, [
                          _c("form", { on: { submit: _vm.saveComment } }, [
                            _c("input", {
                              attrs: { type: "hidden", name: "order_id" },
                              domProps: { value: order.id },
                            }),
                            _vm._v(" "),
                            _c(
                              "textarea",
                              {
                                staticClass: "form-control",
                                attrs: { name: "comment", rows: "3" },
                                on: {
                                  change: function ($event) {
                                    return _vm.showCommentButton(order.id)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(order.comment))]
                            ),
                            _vm._v(" "),
                            order.comment_btn
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-info btn-sm",
                                    attrs: { type: "submit" },
                                  },
                                  [
                                    _vm._v(
                                      "Сохранить\n                            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { attrs: { "data-cname": "Препараты" } },
                          _vm._l(order.preps, function (p, index3) {
                            return _c("div", { key: index3 }, [
                              _c(
                                "div",
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex" },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(p.drug.prep) +
                                            " (" +
                                            _vm._s(p.prep) +
                                            ") - " +
                                            _vm._s(p.num) +
                                            "шт"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      p.drug.commentsbypak
                                        ? [
                                            _c("div", [
                                              _c("i", {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName: "v-tooltip",
                                                    value: {
                                                      content:
                                                        p.drug.commentsbypak,
                                                      placement:
                                                        "bottom-center",
                                                      classes: ["info"],
                                                      targetClasses: [
                                                        "it-has-a-tooltip",
                                                      ],
                                                      offset: 20,
                                                      delay: {
                                                        show: 500,
                                                        hide: 300,
                                                      },
                                                    },
                                                    expression:
                                                      "{\n                                              content: p.drug.commentsbypak,\n                                              placement: 'bottom-center',\n                                              classes: ['info'],\n                                              targetClasses: ['it-has-a-tooltip'],\n                                              offset: 20,\n                                              delay: {\n                                                show: 500,\n                                                hide: 300,\n                                              },\n                                            }",
                                                  },
                                                ],
                                                staticClass:
                                                  "icon-fa icon-fa-info-circle",
                                              }),
                                            ]),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      p.drug.computation_comment
                                        ? [
                                            _c("div", [
                                              _c("i", {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName: "v-tooltip",
                                                    value: {
                                                      content:
                                                        p.drug
                                                          .computation_comment,
                                                      placement:
                                                        "bottom-center",
                                                      classes: ["info"],
                                                      targetClasses: [
                                                        "it-has-a-tooltip",
                                                      ],
                                                      offset: 20,
                                                      delay: {
                                                        show: 500,
                                                        hide: 300,
                                                      },
                                                    },
                                                    expression:
                                                      "{\n                                          content: p.drug.computation_comment,\n                                          placement: 'bottom-center',\n                                          classes: ['info'],\n                                          targetClasses: ['it-has-a-tooltip'],\n                                          offset: 20,\n                                          delay: {\n                                            show: 500,\n                                            hide: 300,\n                                          },\n                                        }",
                                                  },
                                                ],
                                                staticClass:
                                                  "icon-fa icon-fa-home",
                                              }),
                                            ]),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _vm.runnerTasks &&
                                  _vm.runnerTasks.newQuatity[order.id] &&
                                  _vm.runnerTasks.newQuatity[order.id][p.prep]
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          _vm.runnerTasks.newQuatity[order.id][
                                            p.prep
                                          ],
                                          function (req, index4) {
                                            return _c(
                                              "div",
                                              { staticClass: "qnty_requests" },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(req.created_at)
                                                  ),
                                                ]),
                                                _vm._v(" новое количество: "),
                                                _c("strong", [
                                                  _vm._v(_vm._s(req.qnty)),
                                                ]),
                                                _vm._v(
                                                  " шт.\n                                        "
                                                ),
                                                req.status == 3
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "rejected_status",
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v("Отказ"),
                                                        ]),
                                                        _vm._v(
                                                          " - " +
                                                            _vm._s(
                                                              req.comment
                                                            ) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                req.status == 2
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "approved_status",
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v("Подтвержден"),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.type != "viewOrder"
                                    ? [
                                        _vm.newQuantity[order.id]
                                          ? _c(
                                              "div",
                                              { staticClass: "flex" },
                                              [
                                                _c("vue-number-input", {
                                                  attrs: {
                                                    min: 0,
                                                    max: 100,
                                                    inputtable: false,
                                                    inline: "",
                                                    controls: "",
                                                  },
                                                  on: { click: _vm.refresh },
                                                  model: {
                                                    value:
                                                      _vm.newQuantity[order.id][
                                                        p.prep
                                                      ],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newQuantity[
                                                          order.id
                                                        ],
                                                        p.prep,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newQuantity[order.id][p.prep]",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _vm.newQuantity[order.id][
                                                  p.prep
                                                ] !=
                                                _vm.prepQuantity[order.id][
                                                  p.prep
                                                ]
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-success",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.updateOrder(
                                                              $event,
                                                              order.id,
                                                              "newQuantity",
                                                              p.prep
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "OK\n                                        "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ])
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm.type != "viewOrder"
                          ? _c(
                              "td",
                              { attrs: { "data-cname": "Отмена заявки" } },
                              [
                                !order.showRejectMenu
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-danger btn-xs",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showRejectMenu(order.id)
                                          },
                                        },
                                      },
                                      [_vm._v("Отказ")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                order.showRejectMenu
                                  ? _c("div", [
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: order.prichina_otkaza,
                                            expression: "order.prichina_otkaza",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          placeholder: "Причина отказа",
                                          rows: "3",
                                        },
                                        domProps: {
                                          value: order.prichina_otkaza,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              order,
                                              "prichina_otkaza",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-danger btn-xs w-100",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateOrder(
                                                $event,
                                                order.id,
                                                "rejectOrder"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Отказ")]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.type != "viewOrder"
                          ? _c(
                              "td",
                              { attrs: { "data-cname": "Заявка обработана" } },
                              [
                                _c("toggle-button", {
                                  attrs: {
                                    labels: { checked: "Ok", unchecked: "" },
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.updateOrderMarket(
                                        $event,
                                        order.id
                                      )
                                    },
                                  },
                                  model: {
                                    value: order.runnerOrderStatus,
                                    callback: function ($$v) {
                                      _vm.$set(order, "runnerOrderStatus", $$v)
                                    },
                                    expression: "order.runnerOrderStatus",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
            _vm._v(" "),
            _vm.type != "viewOrder"
              ? _c("div", { staticClass: "flex flex_between" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-info",
                      on: { click: _vm.saveLineOrder },
                    },
                    [_vm._v("Обровить порядок")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      on: { click: _vm.saveLineOrder },
                    },
                    [_vm._v("Закончить прозвон")]
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-right" }, [
      _c(
        "button",
        { staticClass: "btn btn-success btn-xs", attrs: { type: "submit" } },
        [_vm._v("Сохранить")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }